export enum FormStatus {
  Draft = 1,
  Pending = 2,
  Active = 3,
  Completed = 4,
}
